"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _clsx = _interopRequireDefault(require("clsx"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _MoreVert = _interopRequireDefault(require("@material-ui/icons/MoreVert"));
var _ClickAwayListener = _interopRequireDefault(require("@material-ui/core/ClickAwayListener"));
var _Popper = _interopRequireDefault(require("@material-ui/core/Popper"));
var _Grow = _interopRequireDefault(require("@material-ui/core/Grow"));
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
var _Menu = require("../Menu");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      zIndex: 2
    },
    iconButton: {
      position: 'absolute',
      top: theme.spacing(1),
      right: theme.spacing(1),
      padding: 0
    },
    listIcon: {
      width: 32
    },
    red: {
      color: theme.palette.red.main
    },
    "default": {
      color: theme.palette.darkGrey.main
    },
    paper: {
      boxShadow: theme.customShadows.small,
      borderRadius: 5
    }
  };
});
var ContextMenu = function ContextMenu(_ref) {
  var items = _ref.items,
    iconButtonClassName = _ref.iconButtonClassName,
    iconButtonIcon = _ref.iconButtonIcon,
    iconButtonProps = _ref.iconButtonProps,
    popperProps = _ref.popperProps,
    paperProps = _ref.paperProps;
  var classes = useStyles();
  var anchorRef = _react["default"].useRef(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var handleToggle = function handleToggle() {
    setOpen(function (prevState) {
      return !prevState;
    });
  };
  var handleClose = function handleClose(event) {
    if (anchorRef.current && anchorRef.current.contains(event.target)) return;
    setOpen(false);
  };
  var handleClick = function handleClick(e, onClick) {
    e.stopPropagation();
    onClick(e);
    handleToggle();
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], _extends({
    "aria-label": "menu",
    className: (0, _clsx["default"])(iconButtonClassName, classes.iconButton),
    onClick: handleToggle,
    ref: anchorRef
  }, iconButtonProps), iconButtonIcon || /*#__PURE__*/_react["default"].createElement(_MoreVert["default"], null)), /*#__PURE__*/_react["default"].createElement(_Popper["default"], _extends({
    className: classes.root,
    anchorEl: anchorRef.current,
    open: open,
    transition: true,
    disablePortal: true,
    placement: "left-start"
  }, popperProps), function (_ref2) {
    var TransitionProps = _ref2.TransitionProps,
      placement = _ref2.placement;
    return /*#__PURE__*/_react["default"].createElement(_Grow["default"], _extends({}, TransitionProps, {
      style: {
        transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'
      }
    }), /*#__PURE__*/_react["default"].createElement(_Paper["default"], _extends({
      className: classes.paper
    }, paperProps), /*#__PURE__*/_react["default"].createElement(_ClickAwayListener["default"], {
      onClickAway: handleClose
    }, /*#__PURE__*/_react["default"].createElement(_Menu.MenuList, {
      autoFocusItem: open
    }, items.map(function (_ref3) {
      var name = _ref3.name,
        _onClick = _ref3.onClick,
        color = _ref3.color,
        icon = _ref3.icon;
      return /*#__PURE__*/_react["default"].createElement(_Menu.MenuItem, {
        key: name,
        onClick: function onClick(e) {
          return handleClick(e, _onClick);
        },
        className: classes[color || 'default']
      }, icon, name);
    })))));
  }));
};
ContextMenu.propTypes = {
  items: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string,
    onClick: _propTypes["default"].func,
    color: _propTypes["default"].oneOf(['default', 'red']),
    icon: _propTypes["default"].node
  })).isRequired,
  iconButtonClassName: _propTypes["default"].string,
  iconButtonIcon: _propTypes["default"].element,
  iconButtonProps: _propTypes["default"].shape({
    color: _propTypes["default"].oneOf(['default', 'primary', 'secondary', 'inherit']),
    size: _propTypes["default"].oneOf(['small', 'medium']),
    edge: _propTypes["default"].oneOf(['start', 'end', false])
  }),
  popperProps: _propTypes["default"].shape({
    placement: _propTypes["default"].oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top'])
  }),
  paperProps: _propTypes["default"].shape({
    variant: _propTypes["default"].oneOf(['elevation', 'outlined'])
  })
};
ContextMenu.defaultProps = {
  iconButtonClassName: undefined,
  iconButtonIcon: undefined,
  iconButtonProps: undefined,
  popperProps: undefined,
  paperProps: undefined
};
var _default = exports["default"] = ContextMenu;